/**
 * @class
 * @extends P3.Button
 */
export default class Button extends P3.Button {
    /**
     * @param {ButtonStates} states
     */
    constructor(states) {
        super(states);
      //  this.cursor = 'hover'; // use custom cursor
    }
}